function extractMenuData() {
    const menuData = [];
    const mainMenu = document.querySelector('.navigation-menu.navigation-main');
    if (!mainMenu) {
        console.error('Không tìm thấy menu chính');
        return menuData;
    }
    const menuItems = mainMenu.querySelectorAll(':scope > li.navigation-item');
    menuItems.forEach(item => {
        const menuItem = extractMenuItem(item);
        if (menuItem) {
            menuData.push(menuItem);
        }
    });
    return menuData;
}
function extractMenuItem(item) {
    const link = item.querySelector(':scope > a');
    if (!link) return null;
    const name = link.cloneNode(true);
    name.querySelectorAll('svg').forEach(svg => svg.remove());
    const nameText = name.textContent.trim();
    const url = link.getAttribute('href') || '#';
    const menuItem = {
        name: nameText,
        url: url
    };
    const subMenu = item.querySelector(':scope > .navigation-sub-menu');
    if (subMenu) {
        const children = extractSubMenuData(subMenu);
        if (children && children.length > 0) {
            menuItem.children = children;
        }
    }
    
    return menuItem;
}

function extractSubMenuData(subMenu) {
    const children = [];
    
    // Get feature tiles (second level after Car Parts) such as Service Parts, Braking, etc.
    const featureLinks = subMenu.querySelectorAll('.mega-menu-column-feature a');
    const featureItems = [];
    featureLinks.forEach(link => {
        const name = link.textContent.trim();
        const url = link.getAttribute('href') || '#';
        if (name) {
            featureItems.push({ name, url });
        }
    });
    
    // Get all mega-menu-columns sets (each corresponds to a feature item by index)
    const allColumnSets = Array.from(subMenu.querySelectorAll('.mega-menu-columns'));
    
    // Helper function to extract columns from a column set
    function extractColumnsFromSet(columnSet) {
        const columnItems = [];
        const columns = columnSet.querySelectorAll('.mega-menu-column');
        columns.forEach(column => {
            const columnTitle = column.querySelector('.mega-menu-column-title');
            if (columnTitle) {
                const titleName = columnTitle.textContent.trim();
                const titleUrl = columnTitle.getAttribute('href') || '#';
                
                const columnItem = {
                    name: titleName,
                    url: titleUrl
                };
                
                const columnList = column.querySelector('.mega-menu-column-list');
                if (columnList) {
                    const columnChildren = extractColumnListItems(columnList);
                    if (columnChildren && columnChildren.length > 0) {
                        columnItem.children = columnChildren;
                    }
                }
                
                columnItems.push(columnItem);
            } else {
                const columnList = column.querySelector('.mega-menu-column-list');
                if (columnList) {
                    const columnChildren = extractColumnListItems(columnList);
                    columnItems.push(...columnChildren);
                }
            }
        });
        return columnItems;
    }
    
    // Assign columns to features by index (feature[index] gets columns from mega-menu-columns[index])
    featureItems.forEach((feature, index) => {
        const featureItem = {
            name: feature.name,
            url: feature.url
        };
        
        // Get columns from corresponding mega-menu-columns set
        if (index < allColumnSets.length) {
            const columnItems = extractColumnsFromSet(allColumnSets[index]);
            if (columnItems.length > 0) {
                featureItem.children = columnItems;
            }
        }
        
        children.push(featureItem);
    });
    
    // If no features but there are column sets, return columns from first set
    if (featureItems.length === 0 && allColumnSets.length > 0) {
        return extractColumnsFromSet(allColumnSets[0]);
    }
    
    return children;
}

function extractColumnListItems(columnList) {
    const items = [];
    
    const listItems = columnList.querySelectorAll(':scope > li.navigation-item');
    
    listItems.forEach(li => {
        const link = li.querySelector(':scope > a');
        if (!link) return;
        const name = link.cloneNode(true);
        name.querySelectorAll('svg').forEach(svg => svg.remove());
        const nameText = name.textContent.trim();
        
        const url = link.getAttribute('href') || '#';
        
        const item = {
            name: nameText,
            url: url
        };
        const nestedSubMenu = li.querySelector(':scope > .navigation-sub-menu');
        if (nestedSubMenu) {
            const nestedChildren = extractSubMenuData(nestedSubMenu);
            if (nestedChildren && nestedChildren.length > 0) {
                item.children = nestedChildren;
            }
        }
        
        items.push(item);
    });
    
    return items;
}

const menuData = extractMenuData();
console.log(menuData);

function renderMenuLevel(items, level = 0, parentTitle = '', parentUrl = '') {
    if (!items || items.length === 0) return null;
    
    const menuLevel = document.createElement('div');
    menuLevel.className = 'menu-level';
    menuLevel.dataset.level = level;
    
    if (level > 0) {
        const backButton = document.createElement('div');
        backButton.className = 'menu-back-button';
        
        const backButtonContent = document.createElement('div');
        backButtonContent.className = 'menu-back-button-content';
        backButtonContent.innerHTML = `
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            <span>${parentTitle}</span>
        `;
        
        const viewAllLink = document.createElement('a');
        viewAllLink.href = parentUrl;
        viewAllLink.textContent = 'View All';
        viewAllLink.className = 'menu-header-view-all';
        
        backButtonContent.addEventListener('click', function(e) {
            e.preventDefault();
            const mobileMenuNav = document.getElementById('mobile-menu-nav');
            const currentLevel = mobileMenuNav.querySelector('.menu-level.active');
            if (currentLevel) {
                currentLevel.classList.remove('active');
                setTimeout(() => {
                    currentLevel.remove();
                }, 300);
                
                const prevLevel = currentLevel.previousElementSibling;
                if (prevLevel && prevLevel.classList.contains('menu-level')) {
                    prevLevel.classList.remove('prev');
                    prevLevel.classList.add('active');
                }
            }
        });
        
        backButton.appendChild(backButtonContent);
        backButton.appendChild(viewAllLink);
        menuLevel.appendChild(backButton);
    }
    
    const ul = document.createElement('ul');
    ul.className = 'menu-list';
    
    items.forEach(item => {
        let a;
        const li = document.createElement('li');
        if(item?.children){
            a = document.createElement('div');
        }else{
            a = document.createElement('a');
            a.href = item.url;
        }
        a.textContent = item.name;
        
        if (item.children && item.children.length > 0) {
            const arrow = document.createElement('span');
            arrow.className = 'menu-arrow';
            arrow.innerHTML = `
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 18l6-6-6-6"/>
                </svg>
            `;
            a.appendChild(arrow);
            
            // Check if this is the last level (no children have children)
            const isLastLevel = !item.children.some(child => child.children && child.children.length > 0);
            
            if (isLastLevel) {
                // Expand/collapse for last level
                const subUl = document.createElement('ul');
                subUl.className = 'menu-sub-list';
                subUl.style.display = 'none';
                
                item.children.forEach(child => {
                    const subLi = document.createElement('li');
                    const subA = document.createElement('a');
                    subA.href = child.url;
                    subA.textContent = child.name;
                    subLi.appendChild(subA);
                    subUl.appendChild(subLi);
                });
                
                // Add "View All" item at the end
                const viewAllLi = document.createElement('li');
                viewAllLi.className = 'menu-view-all';
                const viewAllA = document.createElement('a');
                viewAllA.href = item.url;
                viewAllA.textContent = 'View All';
                viewAllLi.appendChild(viewAllA);
                subUl.appendChild(viewAllLi);
                
                a.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (subUl.style.display === 'none') {
                        subUl.style.display = 'block';
                        arrow.style.transform = 'rotate(90deg)';
                    } else {
                        subUl.style.display = 'none';
                        arrow.style.transform = 'rotate(0deg)';
                    }
                });
                
                // Append a first, then subUl
                li.appendChild(a);
                li.appendChild(subUl);
            } else {
                // Open new menu level for non-last levels
                a.addEventListener('click', function(e) {
                    e.preventDefault();
                    const mobileMenuNav = document.getElementById('mobile-menu-nav');
                    const currentLevel = mobileMenuNav.querySelector('.menu-level.active');
                    if (currentLevel) {
                        currentLevel.classList.remove('active');
                        currentLevel.classList.add('prev');
                    }
                    
                    const nextLevel = renderMenuLevel(item.children, level + 1, item.name, item.url);
                    if (nextLevel) {
                        mobileMenuNav.appendChild(nextLevel);
                        setTimeout(() => {
                            nextLevel.classList.add('active');
                        }, 10);
                    }
                });
                
                // Append link for non-last levels too
                li.appendChild(a);
            }
        } else {
            // No children, just append the link
            li.appendChild(a);
        }
        
        ul.appendChild(li);
    });
    
    menuLevel.appendChild(ul);
    if (level === 0) {
        menuLevel.classList.add('active');
    }
    
    return menuLevel;
}

function renderMobileMenu(menuData, container) {
    if (!container || !menuData || menuData.length === 0) return;
    
    container.innerHTML = ''; 
    
    const firstLevel = renderMenuLevel(menuData, 0);
    if (firstLevel) {
        container.appendChild(firstLevel);
    }
}

function resetMenuToFirstLevel() {
    const mobileMenuNav = document.getElementById('mobile-menu-nav');
    if (!mobileMenuNav) return;
    
    const allLevels = mobileMenuNav.querySelectorAll('.menu-level');
    allLevels.forEach((level, index) => {
        if (index > 0) {
            level.remove();
        } else {
            level.classList.remove('prev');
            level.classList.add('active');
        }
    });
}

function initMobileMenu() {
    const mobileMenuNav = document.getElementById('mobile-menu-nav');
    if (mobileMenuNav && menuData && menuData.length > 0) {
        renderMobileMenu(menuData, mobileMenuNav);
    }
   
    const closeMenu = document.querySelector('.head-slot-nav-link.head-slot-nav-mobile-link');
    if(closeMenu){
        closeMenu.addEventListener('click', function() {
            resetMenuToFirstLevel();
        });
    }
}
 

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
} else {
    initMobileMenu();
}